<template>
  <b-card
    class="mb-0 h-100 hover"
    body-class="d-flex flex-direction-column"
  >
    <span class="hover-visible edit-gallery-item shadow">
      <b-button
        v-b-modal.edit-video-item-modal
        class="p-0 h-100"
        size="sm"
        variant="link"
        @click="editVideo(video)"
      >
        <GjIcon
          class="text-secondary"
          name="Edit"
        />
      </b-button>
    </span>
    <a
      @click="previewVideo"
    >
      <b-card
        class="border mb-2"
        body-class="p-0"
      >
        <div
          :style="{ backgroundImage: 'url(' + video.thumbnailUrl + ')' }"
          class="item-image text-center mx-auto"
        />
      </b-card>
    </a>
    <div
      class="position-relative d-inline"
    >
      <b-card-title
        class="mb-1"
      >
        {{ video.title }}
      </b-card-title>
    </div>
    <div class="mt-auto">
      <p
        v-for="(metadata,index) in video.metadata"
        :key="index"
        class="mb-50 metadata-txt"
      >
        <span>
          {{ metadata.key }}:
        </span>
        <span class="text-secondary">
          {{ metadata.value }}
        </span>
      </p>
    </div>
    <video-preview-modal
      ref="videoPreview"
      :video-model="video"
    />

    <div v-if="video.editMode">
      <b-modal
        id="edit-video-item-modal"
        :title="$tk('ClientPortal.Form.Actions.EditTitle')"
        :ok-title="$tk('ClientPortal.Form.Actions.Save')"
        :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
        centered
        cancel-variant="outline-secondary"
        no-enforce-focus
        @hidden="cancelEditVideo(video)"
        @ok="saveVideo(video)"
      >
        <b-form-group
          class="mb-0"
        >
          <b-form-input
            v-model="video.title"
            class="pr-5"
            type="text"
          />
        </b-form-group>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import VideoPreviewModal from '@/components/VideoPreviewModal.vue'
import GalleryService from '@/api/client/gallery.service'
import notification from '@/mixins/toastification'

export default {
  components: {
    GjIcon,
    VideoPreviewModal,
  },
  mixins: [notification],
  props: {
    video: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      temporaryTitle: '',
    }
  },
  methods: {
    editVideo(video) {
      this.$set(video, 'editMode', true)
      this.temporaryTitle = this.video.title
    },
    cancelEditVideo(video) {
      this.$set(video, 'editMode', false)
      this.video.title = this.temporaryTitle
    },
    previewVideo() {
      this.$refs.videoPreview.previewVideo()
    },
    async saveVideo(video) {
      const videoTitle = video.title
      try {
        const response = await GalleryService.updateVideo(video.id, video, this.$route.params.accountId)
        if (response.saved) {
          this.video.title = videoTitle
          this.success(response.message)
          this.$set(video, 'editMode', false)
        } else { this.error(response.message) }
      } catch (error) {
        this.error(error.message)
      }
    },
  },
}
</script>

<!-- Create new scss file if you add more than two classes inside component -->
<style lang="scss">
@import '@/assets/scss/views/client/ads-manager/gallery/gallery-item.scss';
</style>
